const selectTarifarios = (state) => state.tarifario.list;
const selectTarifariosCount = (state) => state.tarifario.count;
const selectTarifario = (state) => state.tarifario.model;
const selectRelatedDuplicataModel = (state) => state.tarifario.related.model.duplicata;
const selectRelatedEmailModel = (state) => state.tarifario.related.model.email;
const selectHistoryModel = (state) => state.tarifario.historyModel;
const selectStatus = (state) => state.tarifario.status;
const selectRefresh = (state) => state.tarifario.refresh;
const selectMode = (state) => state.tarifario.mode.main;
const selectBackgroundMode = (state) => state.tarifario.mode.background;
const selectSubMode = (state) => state.tarifario.mode.sub;
const selectConfigControl = (state) => state.tarifario.config.control;
const selectError = (state) => state.tarifario.error;
const selectResponse = (state) => state.tarifario.response;
const selectSubBackgroundMode = (state) => state.tarifario.mode.subBackground;
const selectUnidadesSelecionadas = (state) => state.tarifario.unidadesNegocioSelecionadas;

const tarifarioSelectors = {
  selectTarifarios,
  selectTarifario,
  selectRelatedDuplicataModel,
  selectRelatedEmailModel,
  selectHistoryModel,
  selectStatus,
  selectRefresh,
  selectMode,
  selectBackgroundMode,
  selectSubMode,
  selectConfigControl,
  selectError,
  selectResponse,
  selectTarifariosCount,
  selectSubBackgroundMode,
  selectUnidadesSelecionadas,
};

export {
  tarifarioSelectors,
  selectTarifarios,
  selectTarifario,
  selectRelatedDuplicataModel,
  selectRelatedEmailModel,
  selectHistoryModel,
  selectStatus,
  selectRefresh,
  selectMode,
  selectBackgroundMode,
  selectSubMode,
  selectConfigControl,
  selectError,
  selectResponse,
  selectTarifariosCount,
  selectSubBackgroundMode,
  selectUnidadesSelecionadas,
};
